import AppContext from "PFApp/app_context";
import { Button } from "PFComponents/button";
import ButtonLink from "PFComponents/button/button_link";
import PageCard from "PFComponents/page/page_card";
import { GROWL_ACTIONS } from "PFReducers/growl_reducer";
import { Account } from "PFTypes/account";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import css from "./destroy_account_page.less";

type DestroyAccountPageProps = {
  account: Account;
  deleteAccount: Function;
};

export const DestroyAccountPage = ({ account, deleteAccount }: DestroyAccountPageProps) => {
  const { t } = useTranslation(["saasAdmin", "translation"]);
  const history = useHistory();
  const { dispatch } = useContext(AppContext);

  const handleSubmit = () => {
    const confirmedDestroy = confirm(t("saasAdmin:accounts.destroy.confirm"));
    if (confirmedDestroy) {
      deleteAccount(account.id)
        .then(() => {
          dispatch({
            type: GROWL_ACTIONS.GROWL_RENDER,
            payload: {
              message: t("saasAdmin:accounts.destroy.success", { name: account.name }),
              kind: "success"
            }
          });
          history.push("/saas_admin/accounts");
        })
        .catch(() => {
          dispatch({
            type: GROWL_ACTIONS.GROWL_RENDER,
            payload: {
              message: t("saasAdmin:accounts.destroy.fail", { name: account.name }),
              kind: "error"
            }
          });
        });
    }
  };

  const handleCancel = () => window.history.back();

  if (account === null) {
    return (
      <div className={css.missingAccountPage}>
        <p>{t("saasAdmin:accounts.destroy.notFound")}</p>
        <ButtonLink kind="secondary" href="/saas_admin/accounts">
          {t("saasAdmin:accounts.destroy.notFoundBtn")}
        </ButtonLink>
      </div>
    );
  }

  return (
    <div className={css.destroyAccountPage}>
      <h1>Destroy Account </h1>
      <PageCard>
        <div className={css.destroyAccountMessage}>
          <p
            dangerouslySetInnerHTML={{
              __html: t("saasAdmin:accounts.destroy.warn.intro", { name: account.name, id: account.id })
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: t("saasAdmin:accounts.destroy.warn.tasks", { tasksCount: account.tasksCount })
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: t("saasAdmin:accounts.destroy.warn.owner", {
                name: account.owner.name,
                email: account.owner.email
              })
            }}
          />
          <p
            dangerouslySetInnerHTML={{
              __html: t("saasAdmin:accounts.destroy.warn.areYouSure")
            }}
          />
        </div>
        <div className={css.destroyAccountActions}>
          <Button kind="secondary" onClick={handleCancel}>
            {t("translation:cancel")}
          </Button>
          <Button kind="danger" onClick={handleSubmit}>
            {t("saasAdmin:accounts.destroy.confirmButton")}
          </Button>
        </div>
      </PageCard>
    </div>
  );
};
